// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2jpPl","image":"Header_image__32yOr","name":"Header_name__2vDNg","info":"Header_info__xLhDu","infoRow":"Header_infoRow__3C0mD"};